module.exports = __webpack_public_path__ + "static/media/meetingRoomInactive.8a5f3034.png";